import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';

// A scrollable viewport that calculates whether to enable/disable scrollbars
const ScrollPane = ({ scaledImageSize, viewSize, children }) => (
    <div
        style={{
            position: 'absolute',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            margin: '0 0',
            border: 'none',
            overflowX: scaledImageSize.width > viewSize.width ? 'scroll' : 'hidden',
            overflowY: scaledImageSize.height > viewSize.height ? 'scroll' : 'hidden',
        }}
    >
        {children}
    </div>
);

export default ScrollPane;



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/DesignPane/ScrollPane.jsx